// General API — contact, careers, partners, corporate waitlist, site stats, FAQs
import { API_CONFIG } from "../config/api.config";

const BASE = API_CONFIG.BASE_URL;

const generalApi = {
  // ─── Contact ──────────────────────────────────────────────────────────────────
  submitContactMessage: async (data) => {
    try {
      const response = await fetch(`${BASE}/contact/submit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      return await response.json();
    } catch {
      return { success: false, message: "Network error. Please try again." };
    }
  },

  // ─── Careers ─────────────────────────────────────────────────────────────────
  submitCareerApplication: async (data) => {
    try {
      const response = await fetch(`${BASE}/careers/apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      return await response.json();
    } catch {
      return { success: false, message: "Network error. Please try again." };
    }
  },

  // ─── Partner ─────────────────────────────────────────────────────────────────
  submitPartnerApplication: async (data) => {
    try {
      const response = await fetch(`${BASE}/partners/apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      return await response.json();
    } catch {
      return { success: false, message: "Network error. Please try again." };
    }
  },

  // ─── Corporate Waitlist ───────────────────────────────────────────────────────
  joinCorporateWaitlist: async (email) => {
    try {
      const response = await fetch(`${BASE}/waitlist/join`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      return await response.json();
    } catch {
      return { success: false, message: "Network error. Please try again." };
    }
  },

  // ─── Site Statistics ──────────────────────────────────────────────────────────
  getSiteStats: async () => {
    try {
      const response = await fetch(`${BASE}/stats`);
      if (!response.ok) throw new Error("Failed to fetch stats");
      return await response.json();
    } catch {
      // Return sensible fallbacks so the UI always renders
      return {
        hotels: "20+",
        restaurants: "30+",
        bookings: "2k+",
        satisfactionRate: "99.9%",
      };
    }
  },

  // ─── FAQs ────────────────────────────────────────────────────────────────────
  getFaqs: async (category = null) => {
    try {
      const url = category
        ? `${BASE}/faqs?category=${encodeURIComponent(category)}`
        : `${BASE}/faqs`;
      const response = await fetch(url);
      if (!response.ok) throw new Error("Failed to fetch FAQs");
      return await response.json();
    } catch {
      return [];
    }
  },

  // ─── Office Job Postings ──────────────────────────────────────────────────────
  getJobPostings: async () => {
    try {
      const response = await fetch(`${BASE}/careers/jobs`);
      if (!response.ok) throw new Error("Failed to fetch jobs");
      return await response.json();
    } catch {
      return [];
    }
  },

  // ─── Office Job Application ───────────────────────────────────────────────────
  applyForJob: async (data) => {
    try {
      const response = await fetch(`${BASE}/careers/jobs/apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      return await response.json();
    } catch {
      return { success: false, message: "Network error. Please try again." };
    }
  },
};

export default generalApi;
